import React from "react";
import {Alert, Button, Card, Form, Icon, Input, Modal, Select, Spin, Tooltip, message} from "antd";
import {getFormFieldByType, sanitizeFieldName} from "../../util/methods";
import {fetchSuperMasterFilter, fetchSuperStart} from "../../appRedux/actions";
import {connect} from "react-redux";
import SubList from "../SubList";
import MasterCreateModal from "../MasterModal";
import {createResource as manpower} from "../../appRedux/actions/Manpower";
import {createResource as documentType} from "../../appRedux/actions/DocumentType";
import {createResource as location} from "../../appRedux/actions/Location";
import {createResource as client} from "../../appRedux/actions/Client";
import {createResource as assetType} from "../../appRedux/actions/AssetType";
import {createResource as interval} from "../../appRedux/actions/Interval";
import {createResource as jobType} from "../../appRedux/actions/JobType";
import {createResource as owner} from "../../appRedux/actions/Owner";
import {createResource as sparePart} from "../../appRedux/actions/SparePart";
import {createResource as sparePartType} from "../../appRedux/actions/SparePartType";
import {createResource as status} from "../../appRedux/actions/Status";
import {createResource as unitOfMeasurement} from "../../appRedux/actions/UnitOfMeasurement";
import {createResource as vendor} from "../../appRedux/actions/Vendor";
import {createResource as activityType} from "../../appRedux/actions/ActivityType";
import {createResource as equipmentSubType} from "../../appRedux/actions/EquipmentSubType";
import {createResource as assetModel} from "../../appRedux/actions/AssetModel";
import AccessControl from "../AccessControl";

let context;
// const obj = {
//   manpower: Manpower,
// };

class MasterModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: 1,
      // documentData: [],
      visible: false,
      fields: {
        name: {
          value: '',
        },
        description: {
          value: ''
        }
      },
    };
  }

  componentDidMount() {

    context = this;
  }

  componentWillReceiveProps(nextProps) {

  }

  showModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const {item} = this.props;
    this.props.fetchSuperMasterFilter(item);
    this.setState({
      visible: true,
    });
  };
  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };

  handleChange = (changedFields) => {
    this.setState(({fields}) => ({
      fields: {...fields, ...changedFields},
    }));
  };

  // getDocumentData = (data) => {
  //   this.setState({ documentData: data });
  // };

  handleSubmit = (e) => {
    const {match, item, loading, resource} = this.props;
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      if(err) {
        return console.log(err);
      }

      if (this.isAssetModelPopup()) {
        if (typeof values.modelNumber === 'string') {
          values.modelNumber = values.modelNumber.trim();
          if (!values.modelNumber) {
            delete values.modelNumber;
          }
        }
        const generatedName = this.getGeneratedAssetModelName(values, this.props.superMasterFilters);
        if (!generatedName) {
          message.error('Please select Asset Sub Type and Make to generate the Asset Model Name.');
          return;
        }
        values.name = generatedName;

        // The backend expects these nested-object arrays as JSON strings (matching how the
        // full Asset Model create page already submits them) — otherwise FormData.append()
        // stringifies each entry to "[object Object]" and the save fails with a cast error.
        if (values.standardFuelConsumptionRate) {
          values.standardFuelConsumptionRate = JSON.stringify(values.standardFuelConsumptionRate);
        }
        if (values.fuelMileageThreshold) {
          values.fuelMileageThreshold = JSON.stringify(values.fuelMileageThreshold);
        }
      }

      this.props.fetchSuperStart();
      switch (item) {
        case 'Manpower':
          this.props.manpower(values, false, resource);
          break;
        case 'DocumentType':
          if(this.props.subMaster) {
            this.props.documentType(values, false, resource, true);
          } else {
            this.props.documentType(values, false, resource, false);
          }
          break;
        case 'Location':
          this.props.location(values, false, resource);
          break;
        case 'Client':
          this.props.client(values, false, resource);
          break;
        case 'AssetType':
          this.props.assetType(values, false, resource);
          break;
        case 'Interval':
          this.props.interval(values, false, resource);
          break;
        case 'JobType':
          this.props.jobType(values, false, resource);
          break;
        case 'Owner':
          if(this.props.subMaster) {
            await this.props.owner(values, false, resource, true);
          } else {
            await this.props.owner(values, false, resource, false);
          }
          break;
        case 'SparePart':
          this.props.sparePart(values, false, resource);
          break;
        case 'EquipmentSubType':
          if(this.props.subMaster) {
            await this.props.equipmentSubType(values, false, resource, true);
          } else {
            await this.props.equipmentSubType(values, false, resource, false);
          }
          break;
        case 'AssetModel': {
          let createdAssetModel;
          if(this.props.subMaster) {
            createdAssetModel = await this.props.assetModel(values, false, resource, true);
          } else {
            createdAssetModel = await this.props.assetModel(values, false, resource, false);
          }
          if (createdAssetModel && this.props.onCreated) {
            // The raw create response only has assetSubType/assetMake as ids — enrich with the
            // already-loaded option objects so the caller can show the name, not just the id.
            const superMasterFilters = this.props.superMasterFilters || {};
            const subTypeOptions = (superMasterFilters.assetSubType && superMasterFilters.assetSubType.data && superMasterFilters.assetSubType.data.data) || [];
            const makeOptions = (superMasterFilters.assetMake && superMasterFilters.assetMake.data && superMasterFilters.assetMake.data.data) || [];
            const selectedSubType = subTypeOptions.find((option) => `${option && option._id}` === this.getValueId(values.assetSubType));
            const selectedMake = makeOptions.find((option) => `${option && option._id}` === this.getValueId(values.assetMake));
            this.props.onCreated({
              ...createdAssetModel,
              assetSubType: selectedSubType || createdAssetModel.assetSubType,
              assetMake: selectedMake || createdAssetModel.assetMake,
            });
          }
          if(this.props.form2) {
            this.props.handleSelectAssetSubType(this.props.form2.getFieldValue(`assetDetails[${this.props.index}]['equipmentSubType']`));
          }
          break;
        }
        case 'SparePartType':
          this.props.sparePartType(values, false, resource);
          break;
        case 'Status':
          this.props.status(values, false, resource);
          break;
        case 'UnitOfMeasurement':
          if(this.props.subMaster) {
            this.props.unitOfMeasurement(values, false, resource, true);
          } else {
            this.props.unitOfMeasurement(values, false, resource, false);
          }
          break;
        case 'Vendor':
          await this.props.vendor(values, false, resource);
          break;
        case 'ActivityType':
          if(this.props.subMaster) {
            this.props.activityType(values, false, resource, true);
          } else {
            this.props.activityType(values, false, resource, false);
          }
          break;

        default:
          break;

      }

      if(this.props.subTypeId) {
        await this.props.findAssetModelBySubType(this.props.subTypeId);
      }

      if(!loading) {
        this.setState({visible: false});
        this.props.form.resetFields();
      }
    });

  };

  edit = (id) => {

  };

  openNewSpare = () => {
    window.open('../spare-part/add', '_blank', 'width=600, height=400');
  }

  isAssetModelPopup = () => this.props.item === 'AssetModel'

  getValueId = (value) => {
    if (!value) return null;
    if (typeof value === 'string' || typeof value === 'number') return `${value}`;
    if (typeof value === 'object') {
      const id = value._id || value.id;
      if (id) return `${id}`;
      if (value.toString && value.toString() !== '[object Object]') {
        return `${value.toString()}`;
      }
    }
    return null;
  }

  getInitialAssetSubTypeValue = () => {
    const subTypeId = this.getValueId(this.props.subTypeId);
    if (subTypeId) {
      return subTypeId;
    }
    const selectedChildSubType = this.props.selectedChildValues
      && this.props.selectedChildValues.assetSubType
      && this.props.selectedChildValues.assetSubType.length
      && this.props.selectedChildValues.assetSubType[0];
    const selectedChildSubTypeId = this.getValueId(selectedChildSubType);
    if (selectedChildSubTypeId) {
      return selectedChildSubTypeId;
    }
    if (this.props.form2 && this.props.index !== undefined && this.props.index !== null) {
      const parentFormSubType = this.props.form2.getFieldValue(`assetDetails[${this.props.index}]['equipmentSubType']`);
      const parentFormSubTypeId = this.getValueId(parentFormSubType);
      if (parentFormSubTypeId) {
        return parentFormSubTypeId;
      }
    }
    return undefined;
  }

  getOptionNameById = (field, selectedId, filters = this.props.superMasterFilters) => {
    if (!selectedId || !filters || !filters[field]) {
      return '';
    }
    const selectedIdValue = `${selectedId}`;
    const options = filters[field] && filters[field].data && filters[field].data.data || [];
    const selectedOption = options.find((option) => `${option && option._id}` === selectedIdValue);
    return selectedOption && selectedOption.name || '';
  }

  composeAssetModelName = (assetMakeName = '', assetSubTypeName = '', modelNumber = '') => {
    const normalizedModelNumber = modelNumber && modelNumber.toString().trim() || '';
    const nameParts = [(assetMakeName || '').trim(), (assetSubTypeName || '').trim()];
    if (normalizedModelNumber) {
      nameParts.push(normalizedModelNumber);
    }
    return nameParts.filter(Boolean).join(' ');
  }

  getGeneratedAssetModelName = (values = {}, filters = this.props.superMasterFilters) => {
    const assetSubTypeName = this.getOptionNameById('assetSubType', values.assetSubType, filters);
    const assetMakeName = this.getOptionNameById('assetMake', values.assetMake, filters);
    return this.composeAssetModelName(assetMakeName, assetSubTypeName, values.modelNumber);
  }

  getArrayFieldValue = (fieldName) => {
    const formValues = this.props.form.getFieldValue(fieldName);
    return Array.isArray(formValues) ? formValues : [];
  }

  // Mirrors AssetModel/create.js's getMeterOptionDocs: prefer the populated perType option
  // list already attached to standardFuelConsumptionRate's schema, falling back to the
  // meters field's own option list.
  getMeterOptionDocs = (filters = this.props.superMasterFilters) => {
    const docsFromStdRate = filters &&
      filters.standardFuelConsumptionRate &&
      filters.standardFuelConsumptionRate.schema &&
      filters.standardFuelConsumptionRate.schema.perType &&
      filters.standardFuelConsumptionRate.schema.perType.data &&
      filters.standardFuelConsumptionRate.schema.perType.data.data;
    if (Array.isArray(docsFromStdRate) && docsFromStdRate.length) {
      return docsFromStdRate;
    }
    const docsFromMeters = filters && filters.meters && filters.meters.data && filters.meters.data.data;
    return Array.isArray(docsFromMeters) ? docsFromMeters : [];
  }

  getSelectedMeterIds = () => {
    const selectedMeters = this.getArrayFieldValue('meters');
    const selectedIds = [];
    selectedMeters.forEach((meter) => {
      const meterId = this.getValueId(meter);
      if (meterId && !selectedIds.includes(meterId)) {
        selectedIds.push(meterId);
      }
    });
    return selectedIds;
  }

  // Restricts standardFuelConsumptionRate's "Per Type" choices to only the meters
  // selected in this form's own Meters field, instead of every meter in the org.
  getStandardAvailableMeters = () => {
    const selectedMeterIds = this.getSelectedMeterIds();
    const meterDocs = this.getMeterOptionDocs();
    if (!selectedMeterIds.length || !meterDocs.length) {
      return [];
    }
    return meterDocs.filter((meterDoc) => selectedMeterIds.includes(this.getValueId(meterDoc)));
  }

  onAssetSubTypeChange = () => {
    this.props.form.setFieldsValue({assetMake: undefined});
  }

  renderInlineCreateButton = (fieldConfig = {}, fallbackItem = '') => {
    if (!fieldConfig || !fieldConfig.options || !fieldConfig.options.master) {
      return null;
    }
    const modalItem = fieldConfig.options.ref || fallbackItem;
    return <MasterCreateModal
      subMaster={this.props.subMaster || false}
      superMaster={this.props.superMaster || false}
      pvModule={this.props.pvModule || false}
      resource={this.props.resource}
      item={modalItem}
      title={'CREATE'}
      disableAll={this.props.disableAll}
    />;
  }

  getLabelWithTooltip = (fieldConfig = {}, fallback = '') => {
    const label = sanitizeFieldName(fieldConfig.options && fieldConfig.options.label ? fieldConfig.options.label : fallback);
    return (
      <span>
        {label}&nbsp;
        {fieldConfig.options && fieldConfig.options.description ? (
          <Tooltip title={fieldConfig.options.description}>
            <Icon type="question-circle-o" />
          </Tooltip>
        ) : null}
      </span>
    );
  }

  renderAssetModelNameSection = (filters = this.props.superMasterFilters, form = this.props.form) => {
    if (!filters || !filters.assetSubType || !filters.assetMake) {
      return null;
    }
    const {getFieldDecorator} = form;
    const generatedName = this.getGeneratedAssetModelName({
      assetSubType: form.getFieldValue('assetSubType'),
      assetMake: form.getFieldValue('assetMake'),
      modelNumber: form.getFieldValue('modelNumber'),
    }, filters);
    const modelNumberFilter = filters.modelNumber || {field: 'modelNumber', required: false, options: {label: 'Model Number'}};

    return (
      <div style={{padding: '12px 12px 0 12px', marginBottom: 12, border: '1px solid #d9f7be', borderRadius: 6, background: '#fafafa'}}>
        <Alert
          type="info"
          showIcon
          message="Asset Model Name is generated automatically in the background"
          description="Sequence: Asset Sub Type -> Make -> Model Number (optional)."
          style={{marginBottom: 12}}
        />
        <Form.Item key={'assetSubType'} label={this.getLabelWithTooltip(filters.assetSubType, 'assetSubType')}>
          <div style={{display: 'flex', alignItems: 'center'}}>
            {getFieldDecorator('assetSubType', {
              rules: [{
                required: filters.assetSubType.required,
                message: `${sanitizeFieldName(filters.assetSubType.options && filters.assetSubType.options.label ? filters.assetSubType.options.label : 'assetSubType')} is required!`
              }],
              initialValue: this.getInitialAssetSubTypeValue(),
            })(<Select
              showSearch
              allowClear
              style={{width: '80%'}}
              placeholder="Please select Asset Sub Type"
              onChange={this.onAssetSubTypeChange}
              filterOption={(input, option) =>
                (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
              }
            >
              {(filters.assetSubType.data && filters.assetSubType.data.data || []).map((option) =>
                <Select.Option key={option._id} value={option._id}>{option.name}</Select.Option>)}
            </Select>)}
            {this.renderInlineCreateButton(filters.assetSubType, 'EquipmentSubType')}
          </div>
        </Form.Item>

        <Form.Item key={'assetMake'} label={this.getLabelWithTooltip(filters.assetMake, 'assetMake')}>
          <div style={{display: 'flex', alignItems: 'center'}}>
            {getFieldDecorator('assetMake', {
              rules: [{
                required: filters.assetMake.required,
                message: `${sanitizeFieldName(filters.assetMake.options && filters.assetMake.options.label ? filters.assetMake.options.label : 'assetMake')} is required!`
              }],
            })(<Select
              showSearch
              allowClear
              style={{width: '80%'}}
              placeholder="Please select Make"
              disabled={!form.getFieldValue('assetSubType')}
              filterOption={(input, option) =>
                (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
              }
            >
              {(filters.assetMake.data && filters.assetMake.data.data || []).map((option) =>
                <Select.Option key={option._id} value={option._id}>{option.name}</Select.Option>)}
            </Select>)}
            {this.renderInlineCreateButton(filters.assetMake, 'AssetMake')}
          </div>
        </Form.Item>

        <Form.Item key={'modelNumber'} label={this.getLabelWithTooltip(modelNumberFilter, 'modelNumber')}>
          {getFieldDecorator('modelNumber', {
            rules: [{required: false}],
          })(<Input placeholder={`Please Enter ${sanitizeFieldName(modelNumberFilter.field || 'modelNumber')}`} autoComplete={'off'} />)}
        </Form.Item>

        <Form.Item key={'generatedName'} label="Generated Asset Model Name">
          <Input value={generatedName || 'Will be generated after selecting Asset Sub Type and Make'} disabled />
        </Form.Item>
      </div>
    );
  }


  render() {
    const {item, isDisabled, superMasterFilters, data, history, match, title, loading, form, resource, authUser} = this.props;
    const {getFieldDecorator} = form;
    const {visible} = this.state;
    const isAssetModelInAssetForm = this.isAssetModelPopup();
    const hiddenAssetModelFields = ['name', 'assetSubType', 'assetMake', 'modelNumber', 'standardFuelConsumptionRateHistory'];
    const superMasterFilterKeys = Object.keys(superMasterFilters || {}).filter((itm) => !(isAssetModelInAssetForm && hiddenAssetModelFields.includes(itm)));
    return (
      <span style={{width: '20%', display: 'inline-block'}}>
        <Modal
          title={`Create ${item === 'Client' ? 'Sub Location' : item}`}
          visible={visible}
          onCancel={this.handleCancel}
          footer={null}
        >
          <Spin spinning={loading}>
            <Card className={`gx-card-metrics`}
                  title={`${title} ${sanitizeFieldName(item === 'Client' ? 'subLocation' : item)}`}>
              <Form onSubmit={this.handleSubmit} layout="vertical">
                {isAssetModelInAssetForm ? this.renderAssetModelNameSection(superMasterFilters, form) : null}

                {superMasterFilterKeys.map((itm) => {
                  if(isAssetModelInAssetForm && itm === 'meters') {
                    return <Form.Item key={'meters'} label={this.getLabelWithTooltip(superMasterFilters.meters, 'meters')}>
                      {getFieldDecorator('meters', {
                        rules: [{
                          required: superMasterFilters.meters.required,
                          message: `${sanitizeFieldName(superMasterFilters.meters.options && superMasterFilters.meters.options.label ? superMasterFilters.meters.options.label : 'meters')} is required!`
                        }],
                        initialValue: [],
                      })(<Select
                        showSearch
                        mode="multiple"
                        style={{width: '100%'}}
                        placeholder="Please select Meters"
                        filterOption={(input, option) =>
                          (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                        }
                      >
                        {(superMasterFilters.meters.data && superMasterFilters.meters.data.data || []).map((option) =>
                          <Select.Option key={option._id} value={option._id}>{option.name}</Select.Option>)}
                      </Select>)}
                    </Form.Item>
                  }
                  if(superMasterFilters[itm].type === 'Array' && superMasterFilters[itm].schema) {
                    const isStandardFuelRate = isAssetModelInAssetForm && itm === 'standardFuelConsumptionRate';
                    const standardAvailableMeters = isStandardFuelRate ? this.getStandardAvailableMeters() : null;
                    const other = isStandardFuelRate ? {
                      key: 'standardFuelConsumptionRate',
                      availableMeters: standardAvailableMeters,
                      enforceUniquePerType: true,
                      limitByAvailableOptions: true,
                    } : undefined;
                    return <SubList key={itm} item={superMasterFilters[itm]} form={form} data={[]} title={title}
                                    resource={item} superMaster={true} other={other}
                                    hideAddButton={isStandardFuelRate && !(standardAvailableMeters && standardAvailableMeters.length)}/>
                  } else {
                    if(superMasterFilters[itm].type === 'Array' && superMasterFilters[itm].options.ref === 'Document') {
                      // return <DocumentList match={this.props.match} history={this.props.history} key={itm} item={superMasterFilters[itm]} form={form} data={[]} subDocumentFilters={subDocumentFilters} getDocumentData={this.getDocumentData}/>
                    }
                    return getFormFieldByType(superMasterFilters, itm, getFieldDecorator, {}, {
                      resource: item,
                      superMaster: true,
                      pvModule: this.props.pvModule || false,
                      title: title,
                      assetSubType: this.props.selectedChildValues && this.props.selectedChildValues.assetSubType
                      && this.props.selectedChildValues.assetSubType.length && this.props.selectedChildValues.assetSubType[0] || null,
                    })
                  }
                })}

                <Form.Item>
                  <Button type="primary" className="gx-mb-0" htmlType="button" onClick={this.handleSubmit}
                          loading={loading}>
                    CREATE
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </Spin>

        </Modal>
        {
          this.props && this.props.disableAll ? <AccessControl resource={item} permissionNeeded={'c'}
                                                               roles={authUser ? authUser.roles : []}
                                                               render={(props) => {
                                                                 return <Button type="dashed" disabled={true}
                                                                                onClick={this.showModal} style={{
                                                                   margin: '0',
                                                                   marginTop: '0',
                                                                   marginLeft: '10px',
                                                                   width: 'calc(100% - 10px)'
                                                                 }}>New</Button>
                                                               }}/> :
            <AccessControl resource={item} permissionNeeded={'c'}
                           roles={authUser ? authUser.roles : []} render={(props) => {
              return <Button type="dashed"
                             onClick={item !== 'SparePart' ? this.showModal : this.openNewSpare}
                             style={{
                               margin: '0',
                               marginTop: '0',
                               marginLeft: '10px',
                               width: 'calc(100% - 10px)'
                             }}>New</Button>
            }}/>
        }
      </span>
    )
  }
}

const mapStateToProps = ({commonData, auth}) => {
  return {
    authUser: auth.authUser,
    superMasterFilters: commonData.superMasterFilters,
    // subDocumentFilters: commonData.subDocumentFilters,
    loading: commonData.superLoading,
  }
};

function mapDispatchToProps(dispatch) {
  return {
    fetchSuperMasterFilter,
    manpower,
    documentType,
    location,
    client,
    assetType,
    interval,
    jobType,
    owner,
    sparePart,
    sparePartType,
    status,
    unitOfMeasurement,
    vendor,
    activityType,
    equipmentSubType,
    assetModel,
    // fetchSubDocumentFilter,
    fetchSuperStart,
  };
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    context.handleChange(changedFields);
  }
})(MasterModal);


export default connect(mapStateToProps, mapDispatchToProps())(CreateForm);
